
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import loadPage from '../../components/loadingPage'
import global from '../../../static/js/global'
export default {
data (){
return {
value1:'破坏公物罚款',
value3:'5.0元',
numMoney:'300.0',
aList:[['非业主','业主']],
list1:['非业主'],
alertVal:'',
show_1:false,
value4:'',
value6:'',
value7:'',
value8:'',
hsNo:'',
hsName:'',
m1:true,
m2:false,
m3:false,
billCode:''
}
},
components:{
Flexbox,
FlexboxItem,
XInput,
XButton,
PopupPicker,
loadPage
},
beforeMount(){
this.value1 = this.$router.history.current.query.feeName;
this.value3 = Number(this.$router.history.current.query.feeMoney).toFixed(2);
this.numMoney = Number(this.$router.history.current.query.feeMoney);
this.hsName = this.$router.history.current.query.hsName;
this.hsNo = this.$router.history.current.query.hsNo;
if(this.$router.history.current.path == "/customAmout"){
document.title = this.value1;
}
},
mounted(){
this.changVal();
},
methods:{
changVal(){
this.value3 = Number(this.value3).toFixed(2);
this.numMoney = this.value3.toString();
},
goPay(){
let senddata = new Object();
senddata.comnCode = this.$router.history.current.query.comnCode;
senddata.memberNo = this.$router.history.current.query.mainPhone;
senddata.openid = this.$router.history.current.query.openId;
senddata.tradeAmount = this.numMoney;
senddata.tradeNo = this.billCode;
senddata.tradeName='临时收费';
senddata.tradeDesc='临时收费';
let url = global.host + 'temporaryCharge/getpayurl'
this.$http.post(url,senddata).then(function(res){
if(res.body.code == '110'){
window.location.href = res.body.payurl;
}else{
this.prompt = '支付异常,请稍候再试'
this.submitable = false;
this.showprompt = true;
}

},function(err){
console.log(err)
})
},
changes(){
console.log(this.list1[0])
if(this.list1[0] == "业主"){
this.m1 = false;
this.m2 = true;
this.m3 = true;
}else if(this.list1[0] == "非业主"){
this.m1 = true;
this.m2 = false;
this.m3 = false;
}
},
comval(){
$("#ms1").find(".weui-label").css('color','#000')
},
payFord(){
if(this.hsName == ''){
this.alertVal = '必填项';
$("#ms1").find(".weui-label").css('color','#ff0000')
}else{
if(this.hsNo==null||this.hsNo==''){this.hsNo ='非业主';}
this.show_1 = true;
let usIn = new Object();
usIn.comnCode = this.$router.history.current.query.comnCode;
usIn.feeCode = this.$router.history.current.query.feeCode;
usIn.hsNo = this.hsNo;
usIn.hsName = this.hsName;
usIn.remark = this.value4;
usIn.sumFeeMoney = this.numMoney;
usIn.feeNum = this.$router.history.current.query.feeNum+'';
usIn.calArea = '0';
let url = global.host + 'temporaryCharge/collectTemporary';
this.$http.post(url,usIn).then(function(res){
if(res.body.success == true){
this.billCode = res.body.result;
this.goPay();
}

this.show_1 = false;
},function(err){
console.log(err)
})
}

}
}
}



// WEBPACK FOOTER //
// ./src/components/temporaryCharge/customAmout.vue